import { doc, getDoc, increment, setDoc, updateDoc } from 'firebase/firestore';
import { db, hasFirebaseConfig } from './firebase';

const METRICS_DOC_PATH = ['metrics', 'global'];
const VIEW_COUNT_CACHE_KEY = 'gradevit.totalViews';

export function getCachedGlobalViewCount() {
  try {
    const cachedValue = window.localStorage.getItem(VIEW_COUNT_CACHE_KEY);
    if (cachedValue === null) return null;

    const count = Number(cachedValue);
    return Number.isSafeInteger(count) && count >= 0 ? count : null;
  } catch {
    return null;
  }
}

function cacheGlobalViewCount(count) {
  if (!Number.isSafeInteger(count) || count < 0) return;

  try {
    window.localStorage.setItem(VIEW_COUNT_CACHE_KEY, String(count));
  } catch {
    // The live count still works when storage is blocked or full.
  }
}

export async function incrementGlobalView() {
  if (!hasFirebaseConfig || !db) {
    return { ok: false, reason: 'firebase-not-configured' };
  }

  const metricsRef = doc(db, ...METRICS_DOC_PATH);

  try {
    await updateDoc(metricsRef, { totalViews: increment(1) });
    return { ok: true };
  } catch {
    await setDoc(metricsRef, { totalViews: 1 }, { merge: true });
    return { ok: true };
  }
}

export async function getGlobalViewCount() {
  if (!hasFirebaseConfig || !db) {
    return null;
  }

  try {
    const snapshot = await getDoc(doc(db, ...METRICS_DOC_PATH));
    const count = snapshot.exists() ? Number(snapshot.data().totalViews ?? 0) : 0;
    if (!Number.isSafeInteger(count) || count < 0) return null;

    cacheGlobalViewCount(count);
    return count;
  } catch {
    return null;
  }
}
